import { render, staticRenderFns } from "./MonitoredGroups.vue?vue&type=template&id=2fdf3e56&scoped=true&"
import script from "./MonitoredGroups.vue?vue&type=script&lang=js&"
export * from "./MonitoredGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf3e56",
  null
  
)

export default component.exports